import * as Yup from 'yup'

export const kycTriggerSchema = (curr) => {
  const validationObject = {}
  for (const file in curr) {
    validationObject[curr[file]] = Yup.number().min(0, 'Value must be greater than or equal to 0').nullable()
  }
  return Yup.object(validationObject)
}
